export enum SignageChangeKind {
  Configuration = 'configuration',
  Content = 'content',
  PriorityNews = 'priority-news',
  Live = 'live',
  Diagnostics = 'diagnostics'
}
